// ── Cuota de descargas del plan FREE — lectura sin escritura ──────
// Mismo criterio de reset mensual que la Edge Function
// registrar-descarga-free, pero solo para mostrar el contador en el
// dashboard (no incrementa ni persiste nada).

export const LIMITE_DESCARGAS_FREE = 40;
export const AVISO_DESCARGAS_DESDE = 35;

export const descargasEfectivas = (cuenta) => {
  if (!cuenta) return 0;
  const hoy = new Date();
  const claveActual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, "0")}`;
  const claveGuardada = cuenta.descargas_mes_reset ? String(cuenta.descargas_mes_reset).slice(0, 7) : null;
  return claveGuardada === claveActual ? (cuenta.descargas_mes_actual || 0) : 0;
};
